<template>
    <div class="login-wrap" :style="{ background: 'url(' + userData.pc_loginback_img + ')' }">
        <div style="min-width:1200px;min-height: 900px">
            <div class="logoBox">
                <div style="float: left;height: 100%;display: flex;align-items: center;margin: 0px 35px">
                    <img :src="userData.pc_logo" alt="" style="max-width: 160px">
                </div>
                <div class="otherPages">
                    <a :href="agent" target="_blank" style="color: #ffffff">
                        登录代理人端
                    </a>
<!--                    <p>我是代理人</p>-->
<!--                    <p>我是仲裁委</p>-->
<!--                    <p>我是公证处</p>-->
                </div>
            </div>
            <div class="loginBox">
                <div class="login">
                    <div class="systematicName">
                        <p>案件管理系统</p>
                        <span>企业端</span>
                    </div>
                </div>
                <div class="welcome">
                    <p>欢迎注册</p>
                    <div class="existing">
                        <p>已有账号？</p>
                        <span @click="goLogin" style="cursor:pointer;">立即登录</span>
                    </div>
                </div>
                <div>
                    <el-form :model="ruleForm" :rules="rules"  label-width="100px" class="demo-ruleForm">
                        <el-form-item  prop="name">
                            <el-input v-model="ruleForm.name" placeholder="请输入手机号" maxlength="11" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>
                        </el-form-item>
                        <el-form-item prop="img_code">
                            <div style="display: flex;">
                                <el-input  v-model="ruleForm.img_code" placeholder="请输入图形验证号" maxlength="4" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                <img style="height: 40px" :src="figure.src" @click="changeOver" alt="">
                            </div>
                        </el-form-item>
                        <el-form-item prop="validation">
                            <div style="display: flex;">
                                <el-input  v-model="ruleForm.validation" placeholder="请输入验证号" maxlength="6" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                <el-button @click="getCodes" :disabled="disadles">{{ msgText }}</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input  v-model="ruleForm.password" placeholder="请输入密码" type="password"></el-input>
                        </el-form-item>
                        <el-form-item prop="confirm">
                            <el-input  v-model="ruleForm.confirm" placeholder="请输入再次确认密码" type="password"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="agreement">
                    <el-checkbox v-model="checked">我已阅读并同意 </el-checkbox>
                    <span>《服务协议》</span> <span>《隐私政策》</span>
                </div>
                <div class="Register" @click="goRegister">同意协议并注册</div>
            </div>
        </div>

    </div>
</template>

<script>
    import { figureVerification, userRegistration, validation } from '../../api/login';

    export default {
        name: "registered",
        data(){
            return{
                agent:  '',  //代理人端
                userData:'',
                logoImg:'',
                validation:"",
                disadles: false,
                count: 60,
                msgText: "获取验证码",
                checked:false, //我已阅读并同意
                ruleForm:{
                    name:'', //账号
                    validation:'', // 验证码
                    password:'',  // 密码
                    confirm:'',  //确认密码
                    img_code:'',
                },
                promotion_code:'',
                figure:{},
                rules: {
                    name: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur'}
                    ],
                    img_code:[
                        {required: true, message: '请输入图形验证码', trigger: 'blur'},
                    ],
                    validation:[
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                        {min: 6, max: 6, message: '请输入正确的验证码', trigger: 'blur'}
                    ],
                    password:[
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 6, max: 20, message: '密码最少为6位', trigger: 'blur'}
                    ],
                    confirm:[
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 6, max: 20, message: '密码最少为6位', trigger: 'blur'}
                    ]

                }
            }
        },
        methods:{
            getCodes() {
                validation(this.ruleForm.img_code,this.figure.uniqid,this.ruleForm.name,1).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        let times = 60;
                        let setInter = setInterval(() => {
                            times--;
                            if (times <= 0) {
                                this.msgText = "获取验证码";
                                this.disadles = false;
                                clearInterval(setInter);
                            } else {
                                this.msgText = "重新获取(" + times + ")";
                                this.disadles = true;
                            }
                        }, 1000);
                    }else if (res.code==400){
                        this.$message.error(res.msg);

                    }
                })

            },
            //去登录
            goLogin(){
                this.$router.push('/login')
            },
            //去注册
            goRegister(){
                if(this.ruleForm.password!=this.ruleForm.confirm){
                    this.$message.error("请确保两个密码一致");
                    return;
                }else if (this.checked==false){
                    this.$message.error('请阅读并勾选协议');
                    return
                }
                userRegistration(this.ruleForm.name,this.ruleForm.validation,this.ruleForm.password,this.promotion_code).then(res=>{
                    if(res.code==400){
                        this.$message.error(res.msg);
                        return
                    }else  if (res.code==200){
                        sessionStorage.setItem('token',res.data.token)
                        this.$message.success(res.msg);
                        this.$router.push('/index')
                    }

                })
                // if (this.checked==false){
                //     this.$message.error('请阅读并勾选协议');
                // }else {
                //     this.$router.push('/index')
                // }
            },
            //图形验证码
            changeOver(){
                this.figure.src=this.figure.src+'?='+Math.random()
            },
            fn_Guid() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0,
                        v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },

        },
        created() {
            this.userData = JSON.parse(localStorage.getItem('userData'));
            this.logoImg=JSON.parse(localStorage.getItem('logo'))
            this.promotion_code=sessionStorage.getItem('promotion_code')
            if( this.userData.category==2 ){
                this.agent = `/agent/#/?mark=${this.userData.category_mark}`
            }else{
                this.agent = `/agent`
            }
            if (!sessionStorage.unid) {
                sessionStorage.setItem('unid', this.fn_Guid());
            }
            figureVerification(sessionStorage.unid).then(res=>{
                res.data.src=res.data.src+'?='+Math.random()
                this.figure=res.data
            })
        }
    }
</script>

<style scoped>
    .login-wrap {
        position: relative;
        width: 100%;
        height: 100%;
        background-size: 100% 100% !important;
        /*background-size: cover;*/
        background-position: center center !important;
        overflow: scroll;
    }
    .logoBox{
        width: 80%;
        margin: auto;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

    }
    .otherPages{
        width: 400px;
        display: flex;
        justify-content: flex-end;
        color: #fff;
    }
    /*    登录框*/
    .loginBox{
        width: 400px;
        height: 600px;
        margin-top: 70px;
        background-color: #fff;
        border-radius: 10px;
        /*border: 1px solid black;*/
        box-shadow: 5px 10px 10px -5px #dedede;
        margin-right: 150px;
        float: right;
    }
    .login{
        width: 80%;
        margin: 40px auto;
    }
    .systematicName{
        display: flex;
        align-items: flex-end;
    }
    .systematicName>P{
        margin-right: 20px;
        font-size: 28px;
        color: #1e57dc;
        font-weight: 600;
    }
    .systematicName>span{
        font-size: 16px;
        color: #194ec9;
        font-weight: 600;
    }
    /deep/.el-form-item__content{
        /*margin-left: 0px;*/
        margin: auto !important;
        width: 80%;
    }
    /*欢迎注册*/
    .welcome{
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 25px;
    }
    .welcome>P{
        font-size: 18px;
        color: #1a1a1a;
    }
    .existing{
        display: flex;
        font-size: 14px;
    }
    .existing>span{
        color: #0975e0;
    }
    /deep/.el-input__inner{
        height: 40px;
    }
    .agreement{
        width: 80%;
        margin: auto;
    }
    .agreement>span{
        font-size: 12px;
        color: #1890ff;
        cursor:pointer;
    }
    .Register{
        width: 80%;
        height: 40px;
        margin: 30px auto;
        background-color: #3d62f6;
        color: #fff;
        text-align: center;
        line-height: 40px;
        border-radius: 5px;
        cursor:pointer;

    }
</style>
